<template>
  <div class="floor">
    <div class="titleArea">
      <img :src="titleLineImg" />
      <div class="title" :title="info.name">
        {{ info.name }}
      </div>
      <img class="rightLine" :src="titleLineImg" />
    </div>
    <div class="list">
      <div
        class="item"
        v-for="item in info.entranceList"
        @click="toDetail(item)"
        :key="item.floorId"
      >
        <img :src="item.coverImgUrl" />
        <div class="title-wrap">
          <h2 class="ellipsis" :title="item.title">{{ item.title }}</h2>
          <h3 class="ellipsis" :title="item.subTitle">{{ item.subTitle }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleLineImg from '@/assets/img/activity/title-line.svg'

export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      titleLineImg
    }
  },
  methods: {
    toDetail (item) {
      window.open(item.pcLinkUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
.floor {
  font-family: Alibaba PuHuiTi;
}
.titleArea {
  margin-top: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  .title {
    font-family: Alibaba PuHuiTi;
    font-size: 48px;
    font-weight: bold;
    text-align: center;
    margin: 0 24px;
  }
  .rightLine {
    transform: rotate(180deg);
  }
}
.ellipsis-2 {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.list {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding-top: 36px;
  gap: 20px;
  .item {
    position: relative;
    width: 590px;
    height: 300px;
    border-radius: 16px;
    overflow: hidden;
    cursor: pointer;
    &:hover img {
      transform: scale(1.07);
    }
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      transition: transform 0.8s ease;
      max-height: 300px;
    }
    .title-wrap {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 171px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      color: #fff;
      padding-bottom: 33px;
      h2 {
        font-size: 36px;
        font-weight: bold;
        text-align: center;
        margin: 0;
        padding: 0 12px;
        &:hover {
          text-decoration: underline;
        }
      }
      h3 {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        margin: 0;
        padding: 0 24px;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
